import {AlertIcon, CopilotIcon} from '@primer/octicons-react'
import {Button, Spinner} from '@primer/react'
import type {Ref} from 'react'

type FailureAnalysisButtonStatus = 'loading' | 'ready' | 'error'

export function FailureAnalysisButton({
  status,
  onClick,
  ref,
}: {
  status: FailureAnalysisButtonStatus
  onClick: () => void
  ref?: Ref<HTMLButtonElement>
}) {
  const config = buttonConfig[status]

  return (
    <Button ref={ref} size="small" onClick={onClick} leadingVisual={config.leadingVisual}>
      {config.label}
    </Button>
  )
}

const buttonConfig: Record<FailureAnalysisButtonStatus, {leadingVisual: React.ComponentType; label: React.ReactNode}> =
  {
    loading: {
      leadingVisual: () => <Spinner size="small" />,
      label: (
        <>
          <strong>Copilot</strong> is analyzing CI failures
        </>
      ),
    },
    ready: {
      leadingVisual: CopilotIcon,
      label: 'View failure analysis',
    },
    error: {
      leadingVisual: () => <AlertIcon className="fgColor-attention" />,
      label: 'Failure analysis unavailable',
    },
  }
